import './Zodiac.scss';
import aries from '../../assets/aries.png';
import taurus from '../../assets/taurus.png';
import gemini from '../../assets/gemini.png';
import cancer from '../../assets/cancer.png';
import leo from '../../assets/leo.png';
import virgo from '../../assets/virgo.png';
import libra from '../../assets/libra.png';
import scorpio from '../../assets/scorpio.png';
import sagittarius from '../../assets/sagittarius.png';
import capricorn from '../../assets/capricorn.png';
import aquarius from '../../assets/aquarius.png';
import pisces from '../../assets/pisces.png';


const zodiacData = [
  { img: aries, name: 'Aries' },
  { img: taurus, name: 'Taurus' },
  { img: gemini, name: 'Gemini' },
  { img: cancer, name: 'Cancer' },
  { img: leo, name: 'Leo' },
  { img: virgo, name: 'Virgo' },
  { img: libra, name: 'Libra' },
  { img: scorpio, name: 'Scorpio' },
  { img: sagittarius, name: 'Sagittarius' },
  { img: capricorn, name: 'Capricorn' },
  { img: aquarius, name: 'Aquarius' },
  { img: pisces, name: 'Pisces' },
];

const Zodiac = () => {
  return (
    <div className="zodiac-sign">
      <div className="zodiac-icon">
        {zodiacData.map((sign, index) => (
          <div className="zodiac-item" key={index}>
            <img src={sign.img} alt={sign.name} />
            <span>{sign.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Zodiac;
